module.exports = __webpack_public_path__ + "img/Canton1920.11b75026.jpg";